'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** ./~/.15.3.1@react-dom/index.js
 ** module id = 4
 ** module chunks = 0
 **/